<template>
  <div>
    <b-card class="standardpage border-none">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="bookingpaymentmethods.icon" class="mr-1"></i>
            <span>{{ bookingpaymentmethods.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">

            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Code" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="code" :debounce="bookingpaymentmethods.debounce"
                      placeholder="Code"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!code" @click="code = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Name" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="description" :debounce="bookingpaymentmethods.debounce"
                      placeholder="Description"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!description"
                        @click="description = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Supplier B/L" label-size="sm">
                  <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..." v-model="blac"
                    :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadBLAC"
                    :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                    search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>

            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="bookingpaymentmethods" :icon="bookingpaymentmethods.icon"
            :busy="bookingpaymentmethods.busy" :toolbarlibrary="bookingpaymentmethods.toolbarlibrary"
            :tools="bookingpaymentmethods.tools" :badges="bookingpaymentmethods.badges"
            :fields="bookingpaymentmethods.fields" :items="bookingpaymentmethods.items"
            :limit="bookingpaymentmethods.limit" :downloaded="bookingpaymentmethods.downloaded" :showpages="true"
            :offset="bookingpaymentmethods.offset" :page="bookingpaymentmethods.page" @load="bookingpaymentmethods_load"
            @click="bookingpaymentmethods_click" @changed="bookingpaymentmethods_click('save', $event)"
            @select="bookingpaymentmethods_select">
          </d-table>
        </div>
      </div>

      <div v-show="component">
        <component :is="component" :selection="bookingpaymentmethods.selected" :config="cconfig"
          @discard="bookingpaymentmethods_click('discard')" @go="bookingpaymentmethods_click('go')"></component>
      </div>
      <b-card-footer class="mt-2 ml-1">
        <div class="text-center">
          <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
            <i class="fa fa-cogs mr-2"></i>Setup All
          </b-button>
        </div>
      </b-card-footer>

    </b-card>
  </div>
</template>


<script>
import gql from "graphql-tag";

import BookingPaymentMethodEdit from "./Components/Setup_BookingPaymentMethodEdit";

export default {
  name: "BookingPaymentMethod",
  components: { BookingPaymentMethodEdit },
  watch: {
    async code() {
      await this.bookingpaymentmethods_load(0);
    },
    async description() {
      await this.bookingpaymentmethods_load(0);
    },
    async blac() {
      await this.bookingpaymentmethods_load(0);
    },

  },
  data() {
    return {
      description: null,
      code: null,
      blac: [],

      bookingpaymentmethods: {
        title: "Booking Forms Payment Types",
        icon: "fa fa-list",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,download,clipboard,add,edit,deleteconfirm",
        toolbarlibrary: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-50px",
          },
          {
            key: "code",
            label: "Code",
            sortable: true,
          },
          {
            key: "description",
            label: "Description",
            sortable: true,
          },
          {
            key: "blac",
            label: "Supplier B/L Code",
            sortable: true,
          },
          {
            key: "reasonrequired",
            label: "Reason Required?",
            sortable: true,
          },
          {
            key: "active",
            label: "Active?",
            sortable: true,
          },
          {
            key: "position",
            label: "Position",
            sortable: true,
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },

          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [
          {
            key: "reasonrequired",
            type: "badge",
            Yes: "danger",
            No: "success",
            formatter: (value, key, item) => {
              if (value == '0') {
                return "No";
              } else if (value == '1') {
                return "Yes";
              } else {
                return "";
              }
            },
          },
          {
            key: "active",
            type: "badge",
            Yes: "success",
            No: "danger",
            formatter: (value, key, item) => {
              if (value == '0') {
                return "No";
              } else if (value == '1') {
                return "Yes";
              } else {
                return "";
              }
            },
          },

        ],
        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  async mounted() {
    this.accessdenied();

    await this.bookingpaymentmethods_load();
  },

  methods: {
    accessdenied() {
      this.bookingpaymentmethods.denied = [];
      if (!this.user.permissions.includes("setup_bookingpaymentmethods.admin")) {
        this.bookingpaymentmethods.denied.push("deleteconfirm");
      }
      if (!this.user.permissions.includes("setup_bookingpaymentmethods.admin")) {
        this.bookingpaymentmethods.denied.push("add");
        this.bookingpaymentmethods.denied.push("save");
      }

    },

    async bookingpaymentmethods_load(offset, limit, page) {
      let state = this.bookingpaymentmethods;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,
        code: this.code,
        description: this.description,
        active: this.active,
        blac: this.blac.length > 0 ? this.blac.join(",") : null,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
              query setup_bookingformspaytypes(
                $limit: Int
                $offset: Int
                $code: String
                $description: String
                $blac: String 
                $active: String             
            ) {
              setup_bookingformspaytypes(
                limit: $limit
                offset: $offset
                description: $description
                code: $code
                blac: $blac   
                active: $active                         
              ) {
                id
                code
                description
                blac     
                reasonrequired
                active
                position 
                rows
                updated_at
                updated_by
              }
            }
          `,
          variables,
        });

        // USE LOCAL VARIABLE      

        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.setup_bookingformspaytypes
        } else {
          state.items = response.data.setup_bookingformspaytypes;
        }


      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async bookingpaymentmethods_click(a, ss) {

      let state = this.bookingpaymentmethods;

      switch (a) {
        case "download_view":
          state.downloaded = []
          state.downloaded = state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.bookingpaymentmethods_load(0, 0);
          break;

        case "filter":
          this.showfilter = !this.showfilter;
          break;

        case "discard":
          this.component = null;
          await this.bookingpaymentmethods_load(0);
          break;

        case "go":
          this.component = null;
          await this.bookingpaymentmethods_load(0);
          break;
        case "add":
        case "edit":
          this.component = "BookingPaymentMethodEdit";
          break;

        case "save":
          this.saveit(ss);
          break;

        case "delete":
          this.deleteit(ss);
          break;
      }
    },
    async bookingpaymentmethods_select(ss, tools) {

      let state = this.bookingpaymentmethods;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "download", "clipboard"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async saveit(ss) {

      this.busy = true;

      let variables = { rows: this.cleanit(ss) };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation setup_bookingformspaytypes_save(
                $rows: [setup_bookingformspaytypes_input]             
              ) {
                setup_bookingformspaytypes_save(rows: $rows) {
                  id
                  code
                  description
                  blac              
                  reasonrequired
                  active
                }
              }
            `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    async deleteit(ss) {

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation setup_bookingformspaytypes_delete(
                $rows: [setup_bookingformspaytypes_input]
              ) {
                setup_bookingformspaytypes_delete(rows: $rows) {
                  id
                }
              }
            `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.bookingpaymentmethods_load(0);
    },
  },
};
</script>

<style></style>